import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLang } from "@/i18n";
import { ChevronDown } from "lucide-react";

export default function FAQ() {
  const { t } = useLang();
  const [open, setOpen] = useState(0);
  const faqs = Array.from({ length: 23 }, (_, i) => i + 1).map((n) => ({ q: t(`faq.q${n}`), a: t(`faq.a${n}`) }));
  return (
    <section id="faq" className="py-20 lg:py-28 bg-white" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-5 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }} className="text-center">
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#00AEEF]">{t("faq.kicker")}</p>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#003087] mt-3">{t("faq.title")}</h2>
          <p className="mt-4 text-base text-[#64748B]">{t("faq.sub")}</p>
        </motion.div>

        <div className="mt-12 space-y-3">
          {faqs.map((f, i) => (
            <div key={i} className="card rounded-2xl overflow-hidden" data-testid={`faq-accordion-item-${i}`}>
              <button data-testid={`faq-q-${i + 1}`} onClick={() => setOpen(open === i ? -1 : i)}
                className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left">
                <span className="text-sm sm:text-base font-bold text-[#003087]">{f.q}</span>
                <ChevronDown size={18} className={`text-[#00AEEF] shrink-0 transition-transform duration-300 ${open === i ? "rotate-180" : ""}`} />
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.3 }}>
                    <p className="px-6 pb-6 text-sm text-[#1A1A1A] leading-relaxed">{f.a}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
